import React from 'react';
import {Modal, Text} from '@forecast-it/design-system';
import {FormattedMessage} from 'react-intl';
import Util from '../../../shared/util/util';
import DeleteClientBillTo from '../../../../mutations/invoicing/DeleteClientBillToMutation';

type RemoveClientBillToModalProps = {
	clientId: string;
	clientBillToId: string;
	closeModal: () => void;
};

const RemoveClientBillToModal = ({clientId, clientBillToId, closeModal}: RemoveClientBillToModalProps): JSX.Element => {
	const removeClientBillTo = () => {
		Util.CommitMutation(
			DeleteClientBillTo,
			{
				clientBillToId,
				clientId,
			},
			closeModal
		);
	};

	return (
		<Modal onCloseModal={closeModal}>
			<Modal.Title>
				<FormattedMessage id={'settings_finance.bill_to.unassociate_client'} />
			</Modal.Title>
			<Modal.Content>
				<Text>
					<FormattedMessage id={'settings_finance.bill_to.unassociate_client.description'} />
				</Text>
			</Modal.Content>
			<Modal.Footer>
				<Modal.PrimaryFooterButton onPress={removeClientBillTo}>
					<FormattedMessage id={'common.remove'} />
				</Modal.PrimaryFooterButton>
				<Modal.SecondaryFooterButton onPress={closeModal}>
					<FormattedMessage id={'common.close'} />
				</Modal.SecondaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
};
export default RemoveClientBillToModal;
